import React, { forwardRef, useImperativeHandle } from 'react';
import { pdf } from '@react-pdf/renderer';
import TimesheetPDF from 'pages/Timesheet/TimesheetPDF/TimesheetPDF';

const PdfGenerator = forwardRef(({ data, setIsPdfDownloading }, ref) => {
  const ensurePdfExt = name =>
    name?.toLowerCase().endsWith('.pdf') ? name : `${name}.pdf`;

  useImperativeHandle(ref, () => ({
    async downloadPDF(fileName) {
      setIsPdfDownloading(true);

      try {
        const doc = <TimesheetPDF data={data} />;
        const blob = await pdf(doc).toBlob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = ensurePdfExt(fileName);
        a.click();

        URL.revokeObjectURL(url);
      } catch (error) {
        throw error;
      } finally {
        setIsPdfDownloading(false);
      }
    },
  }));
});

export default PdfGenerator;
